module.exports = __webpack_public_path__ + "img/wali.af092225.png";